
const initialState = null;

export default ( state = initialState, {payload:{property, loadingId, detail} })=>{

    if( !property || !loadingId )
        return state;

    return { ...state, [ property + 'Error' ]: detail? detail:true };

};


// WEBPACK FOOTER //
// ./src/App/services/Api/reducers/error.js